module.exports = __webpack_public_path__ + "img/section_2-svg_3.7794a8f4.svg";